var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[[_c('template',{slot:"activator"},[_vm._t("default")],2),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }